export default __webpack_public_path__ + "static/media/FurnitureItem4.b3619bf4.png";